import { useEffect, useState } from 'react';
import { useColumnContextAPI } from '../../../shared/context/GetAllColumnContext';
import { MenuItem } from '@airbus/components-react';
import { Cached, Upload } from '@airbus/icons/react';
import GridHeaderAction from '../../../shared/components/grid/GridHeaderAction';
import { DisplayDrawingDialog } from './DisplayDrawingDialog';
import { t } from '../../../i18next';
import { uploadCommitHandler } from '../commitHandler';
import Uploader from '../../../shared/components/Upload';
import { DisplayResults } from '../../../shared/components/excel-export/DisplayResults';
import styles from './MoBActions.module.css';

export default function MoBActions(props) {
  const { setAlertbar, rowselectionmodel, rows, editedRowOriginal } = props;
  const { tableFeatureData, accessDetails: access } = useColumnContextAPI();
  const [featureData, setFeatureData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [value, setValue] = useState(false);
  const [keysInAccess, setKeyInAccess] = useState(false);

  const [openResults, setOpenResults] = useState(false);
  const [resultData, setResultData] = useState({ data: [], errors: [] });
  const [templateUrl, setTemplateUrl] = useState<string>(null);
  const [fileName, setFileName] = useState<string>(null);

  useEffect(() => {
    if (tableFeatureData) {
      setFeatureData(tableFeatureData);
      setKeyInAccess(Object.keys(tableFeatureData).some((key) => access[key]));
    }
  }, [tableFeatureData, openFileUpload]);

  const menuItemClickHandler = (key, value) => {
    if (value.featureName !== 'upload_htz_list') {
      rowSelectionMsg({ value, rowselectionmodel, setAlertbar, rows });
    } else {
      setTemplateUrl('https://docs.google.com/spreadsheets/d/1LyUj7vJ_roQQyFApIVme8fbEDWwTnm9s');
      setFileName('UploadReport_HTZlist');
      setOpenFileUpload(true);
      setValue(value);
    }
  };

  const diaplayDrawingLink = (fieldValue) => {
    if (fieldValue) {
      const url = fieldValue.startsWith('https://') ? fieldValue : `https://${fieldValue}`;
      window.open(url);
    } else setOpenDialog(true);
  };

  const rowSelectionMsg = ({ value, rowselectionmodel, setAlertbar, rows }) => {
    if (!rowselectionmodel.length || rowselectionmodel.length > 1) {
      const errorMessage =
        rowselectionmodel.length === 0 ? t('please_select_row') : t('please_select_single_row');
      setAlertbar({
        children: errorMessage,
        severity: 'error',
      });
      return;
    }
    const rowSelected = rows.find((row) => row.id === rowselectionmodel[0]);
    const finalNpiHtz =
      value.featureName === 'show_last_htz'
        ? rowSelected?.npi_htz ?? ''
        : rowSelected?.npi_htz?.slice(0, 10) ?? '';
    if (value.featureName === 'display_drawing') {
      diaplayDrawingLink(rowSelected.pag_drw_hlink);
    } else
      window.open(
        `http://plmprod.de.pa.corp/Windchill/netmarkets/jsp/ext/pag/Go2LatestWtPart.jsp?number=${finalNpiHtz}`,
      );
  };

  return (
    <>
      {keysInAccess && (
        <GridHeaderAction>
          {Object.entries(featureData).map(
            ([key, value]) =>
              key != 'action' &&
              access[key] && (
                <MenuItem
                  className={styles.menuItem}
                  key={key}
                  onClick={() => menuItemClickHandler(key, value)}
                  icon={key !== 'upload_htz_list' ? <Cached className={styles.icons} /> : <Upload className={styles.icons} />}
                >
                  {featureData[key][`featureName`]}
                </MenuItem>
              ),
          )}
        </GridHeaderAction>
      )}
      {openFileUpload && (
        <Uploader
          openFileUpload={openFileUpload}
          setOpenFileUpload={setOpenFileUpload}
          setAlertbar={setAlertbar}
          value={value}
          editedRowOriginal={editedRowOriginal}
          featureCommitHandler={uploadCommitHandler}
          setOpenResults={setOpenResults}
          setResultData={setResultData}
          templateUrl={templateUrl}
        />
      )}
      <DisplayResults
        resultData={resultData}
        setResultData={setResultData}
        primaryKey='htz'
        openResults={openResults}
        setOpenResults={setOpenResults}
        fileName={fileName}
      />
      <DisplayDrawingDialog open={openDialog} setOpen={setOpenDialog} />
    </>
  );
}
